.overlay { position: fixed; inset: 0; z-index: 400; background: var(--scrim); border: none; }

.modal {
  position: fixed;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  z-index: 401;
  width: 1000px; max-width: 96vw; height: 85vh;
  display: flex; flex-direction: column;
  background: var(--card-bg);
  border-radius: var(--r-lg);
  box-shadow: 0 20px 60px rgba(0,0,0,.25);
  overflow: hidden;
}

.header {
  display: flex; align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.title { font-size: 15px; font-weight: 700; }
.subtitle { font-size: 13px; color: var(--text2); margin-top: 2px; }
.spacer { flex: 1; }

.close { background: none; border: none; font-size: 22px; line-height: 1; color: var(--text2); cursor: pointer; }
.close:hover { color: var(--text); }

.filters {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 20px;
  background: var(--table-even);
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
  flex-wrap: wrap;
}

.select, .search {
  padding: 5px 9px;
  font-size: 12.5px;
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  background: var(--card-bg);
  color: var(--text);
}

.search { min-width: 160px; }

.button {
  padding: 5px 12px;
  font-size: 13px;
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  background: var(--card-bg);
  color: var(--text2);
  cursor: pointer;
  white-space: nowrap;
}

.button:hover { border-color: var(--blue); color: var(--blue); }

.body { flex: 1; overflow: auto; }

.table { width: 100%; border-collapse: collapse; }

.table th {
  position: sticky; top: 0; z-index: 1;
  padding: 8px 12px;
  font-size: 12.5px; font-weight: 600;
  color: var(--text2); text-align: left;
  background: var(--card-bg);
  border-bottom: 1px solid var(--border);
}

.table td {
  padding: 7px 12px;
  font-size: 12.5px;
  border-bottom: 1px solid var(--border);
  vertical-align: top;
}

.table tbody tr:nth-child(even) { background: var(--table-even); }

/* События, требующие внимания при разборе: вход, изменение прав,
   удаление. Полоса слева, а не заливка — иначе спорила бы
   с чередованием строк. */
.rowAlert { border-left: 3px solid var(--warn); }

.nowrap { white-space: nowrap; color: var(--text2); }
.mono { font-family: var(--mono); font-size: 13px; }
.details { font-size: 13px; color: var(--text2); max-width: 320px; word-break: break-word; }

.empty { padding: 40px; text-align: center; color: var(--text2); font-size: 13px; }

.error {
  margin: 16px 20px;
  padding: 10px 12px;
  font-size: 12.5px;
  color: var(--err);
  background: var(--err-bg);
  border-radius: var(--r-sm);
}

@media (max-width: 640px) {
  .modal { width: 100%; max-width: 100%; height: 100%; border-radius: 0; top: 0; left: 0; transform: none; }
  .filters { padding: 8px 12px; }
  .details { display: none; }
}
